import styled from '@emotion/styled';

import { Button as MuiButton } from 'components/Buttons';
import { theme } from 'theme';

export const Button = styled(MuiButton)`
  &:focus,
  &:active,
  &:hover {
    box-shadow: none !important;
    background-color: ${({ color }) =>
      color === 'primary'
        ? theme.palette.primary.main
        : theme.palette.secondary.light};
  }
  span {
    font-family: inherit;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
